import { format } from 'date-fns';
import React, { useEffect } from 'react';
import * as S from './styles';

export function EmailsInterest({ emailInteresseConclusao, statusPropose }) {
  console.log(emailInteresseConclusao, statusPropose)
  if (emailInteresseConclusao?.emailInteresseConclusaoId <= 0 || statusPropose) {
    return null;
  }
  return (
    emailInteresseConclusao?.emailInteresseConclusaoId > 0 && (
      <S.MessageContainer>
        <S.TableTitleHeader>
          <h3 className="operation-title">E-mail de Interesse Ou ChatBot - Resposta do Fornecedor</h3>
        </S.TableTitleHeader>
        <S.MessageBody>
          <p className="message-text">
            {emailInteresseConclusao?.conclusao} por {emailInteresseConclusao?.nome}
          </p>
          <p className="message-text">
            {format(new Date(emailInteresseConclusao?.dataRegistro), 'dd/MM/yy HH:mm')}
            <span className="message-ip">IP: {emailInteresseConclusao?.ip}</span>
          </p>
          {emailInteresseConclusao?.mensagem && (
            <p className="message-text">Mensagem: {emailInteresseConclusao?.mensagem}</p>
          )}
        </S.MessageBody>
      </S.MessageContainer>
    )
  );
}
